
import { Options, Vue } from "vue-class-component";
import { kBrandCulturePageContent } from "@/config/Common/brand_culture_data";

@Options({
  components: {},
  data() {
    return {
      info: kBrandCulturePageContent.tenValue,
    };
  },
})
export default class TenValue extends Vue {}
